import { Component, OnInit } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';
@Component({
  selector: 'app-not-same-email',
  templateUrl: './notSameEmail.component.html',
  styleUrls: ['./notSameEmail.component.scss'],
})
export class NotSameEmailComponent implements OnInit {

  constructor(private l10NtranslationService: L10nTranslationService) { }

  ngOnInit(): void {
  }

}
